import * as React from "react";
import { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";

import themeKym from "../../utils/themes/ThemeKym";
import { validateNumber, validateObjectNotApplied } from "../../utils/utils_objects";

export default function ToggleButtonMap(data) {
  let { props, values, setFieldValue, setErrorMSISDN, errorMSISDN } = data;
  const [selected, setSelected] = useState(null);
  const classesKym = themeKym();
  const keys = ["emoney", "epin"];
  let ePin = values.epin_cell_number;
  let eMoney = values.emoney_cell_number;
  let label = props.label;

  let numbers = { epin: ePin, emoney: eMoney };

  const listNumbers = () => {
    if (validateObjectNotApplied(numbers)) {
      setFieldValue(props.name, "");
    }
  };

  useEffect(() => {
    listNumbers();
    if (ePin === "No aplica" || eMoney === "No aplica") setFieldValue(props.name, "");
  }, [values.emoney_cell_number, values.epin_cell_number]);

  const handleClick = (value) => {
    setSelected(value);
    setFieldValue(props.name, value);
    setErrorMSISDN(false);
  };

  return (
    <div>
      <label id={props.id} className={classesKym[`${props.className.labelClassName}`]}>
        {label}
      </label>
      <Grid container justifyContent="start">
        {keys.map(
          (value) =>
            validateNumber(numbers) &&
            numbers[value] !== "No aplica" &&
            numbers[value] !== undefined &&
            numbers[value] !== "" &&
            (value === "epin" ? numbers[value] !== numbers["emoney"] : true) && (
              <Grid key={numbers[value]} mr={1}>
                <ToggleButton
                  key={numbers[value]}
                  value={numbers[value]}
                  selected={selected === numbers[value]}
                  className={
                    classesKym[props.className.toggleButton] +
                    (values.active_cell_number === numbers[value] ? " " + classesKym.toggleSelected : "")
                  }
                  onChange={() => handleClick(numbers[value])}
                >
                  {numbers[value]}
                </ToggleButton>
              </Grid>
            )
        )}
        <Grid style={{ color: "red", fontSize: "12px", textAlign: "justify", display: errorMSISDN ? "block" : "none" }}>
          Es necesario contar con una billetera Tigo Money, acércate a tu supervisor para poder avanzar ...
        </Grid>
      </Grid>
    </div>
  );
}
